import { render, staticRenderFns } from "./BoxWithShadow.vue?vue&type=template&id=6a287b3e&scoped=true&functional=true&"
var script = {}
import style0 from "./BoxWithShadow.vue?vue&type=style&index=0&id=6a287b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6a287b3e",
  null
  
)

export default component.exports